<style lang="scss">
  @use "../../components/shared/tab-body.scss";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_colors.scss"
    as colors;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils.scss"
    as utils;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_mixins.scss"
    as mixins;

  .activity-notes {
    height: 100%;
    overflow: auto;
  }

  .note-mapping-info {
    margin-bottom: 2rem;
    h3 {
      margin: 0;
      @include mixins.h3();
      color: colors.get(textBlack);
    }
    p {
      margin: 0;
      @include mixins.body2();
      color: colors.get("textGrey");
    }
  }
</style>

<script>
  import { writable } from "svelte/store";
  import CustomTabs from "../../components/shared/CustomTabs.svelte";
  import Description from "../../components/shared/Description.svelte";
  import TabContent from "../../components/shared/TabContent.svelte";
  import NoteCreation from "./components/NoteCreation.svelte";
  import NoteMapping from "./components/NoteMapping.svelte";

  import { activeProviderConfigStore, integrationStore } from "../../stores";

  $: providerTitle = $integrationStore.getProviderTitle();
  $: learnMoreLink = $integrationStore.getLearnMoreLink("activityNotes");

  $: description = {
    title: "Activity Notes",
    description: `Choose which SourceWhale activities should create notes in ${providerTitle}, and then map these activities to ${providerTitle}'s note action types to help track ROI.`,
    learnMoreLink,
  };

  const notice =
    "If notes are not mapped, they will be created but will not have a specific action type/category.";

  $: tabItems =
    $activeProviderConfigStore?.syncKinds?.map((kind, index) => ({
      label: kind === "ClientContact" ? "CONTACT" : kind.toUpperCase(),
      slot: `tab${index}`,
      kind,
    })) || [];

  let currentType = writable("");

  $: if (tabItems.length > 0 && !$currentType)
    currentType.set(tabItems[0].kind);

  $: createNotesUpon = $integrationStore.getValue("createNotesUpon");
  $: settings =
    $integrationStore.getSettings("activityNotes", $currentType) || [];
</script>

<div class="activity-notes tab-body">
  <Description {...description} />

  <NoteCreation />

  {#if createNotesUpon.length > 0}
    <div class="note-mapping-info">
      <h3>Note mapping</h3>
      <p>{notice}</p>
    </div>

    <CustomTabs {tabItems} bind:currentType />
    <TabContent
      hasData={settings.length > 0}
      tabCount={tabItems.length}
      emptyMessage="No note mappings available for this type."
    >
      <NoteMapping type={$currentType} {settings} />
    </TabContent>
  {/if}
</div>
